import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayAdjustmentHistoryList extends Layout {
    layoutheaderPendingPayAdjustments: LayoutHeader;
    sourceOffDeductHist: DataSource;
    tablePayAdjustments: Table;
}
